export const EVENTS = {
    CLICK: 'click',
    CHANGE: 'change',
    DELEGATE_SELECT: 'delegateselect',
    OPTIONS_CHANGE: 'optionschange',
};
export const ATTRIBUTES = {
    VALUE: 'value',
    ICON: 'icon',
    DISABLED: 'disabled',
};
